import { apiClient } from 'v4/core/apiClient';
import { createReconciliationApi } from './reconciliation.api.http';

export const myReconciliationApi = createReconciliationApi({
  client: apiClient
});
